<template>
  <div class="status-change-procedure-apply"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="studentInfo">
      <MenuTabs v-model="current"
                title="选择异动类型">
        <el-tab-pane v-for="changeType in changeTypes"
                     :key="changeType.code"
                     :name="changeType.code"
                     :label="changeType.name"
                     lazy>
          <div class="apply-pane">
            <component :is="changeType.component"
                       :student-id="rowData.id"
                       :student-info="studentInfo"
                       :extra-params="extraParams"
                       :visible="visible"
                       v-bind="$attrs"
                       v-on="$listeners"
                       @change-success="onChangeSuccess">
              <div class="apply-student-info">
                <div class="student-info">
                  <div class="info-box">
                    <div class="info-item">
                      <span class="label">姓名：</span>
                      <span class="value bold">
                      <span class="is-primary">{{studentInfo.trueName}}</span>
                    </span>
                    </div>
                    <div v-if="studentInfo.status"
                         class="info-item">
                      <span class="label">学生状态：</span>
                      <span class="value bold">
                      <span :class="studentInfo.status.code | status">{{studentInfo.status.name}}</span>
                    </span>
                    </div>
                    <div v-if="studentInfo.tuitionStatus"
                         class="info-item">
                      <span class="label">缴费状态：</span>
                      <span class="value bold">
                      <span :class="studentInfo.tuitionStatus.code | tuitionStatus">{{studentInfo.tuitionStatus.name}}</span>
                    </span>
                    </div>
                    <div v-if="studentInfo.regNo"
                         class="info-item">
                      <span class="label">学号：</span>
                      <span class="value">{{studentInfo.regNo}}</span>
                    </div>
                    <div class="info-item">
                      <span class="label">教学点：</span>
                      <span class="value">{{studentInfo.siteName}}</span>
                    </div>
                    <div class="info-item">
                      <span class="label">年级：</span>
                      <span class="value">{{studentInfo.gradeName}}</span>
                    </div>
                    <div v-if="studentInfo.className"
                         class="info-item">
                      <span class="label">班级：</span>
                      <span class="value">{{studentInfo.className}}</span>
                    </div>
                  </div>
                  <div class="append">
                    <div class="btn-group">
                      <StudentInfoPopover :popover-title="`学生详细信息 - ${studentInfo.trueName}`"
                                          :student-id="studentInfo.id">
                        <template #default="{toggleVisible}">
                          <el-button class="is-first"
                                     size="mini"
                                     type="primary"
                                     @click="toggleVisible">学生信息详情</el-button>
                        </template>
                      </StudentInfoPopover>
                      <StudentScorePopover :popover-title="`学生成绩信息 - ${studentInfo.trueName}`"
                                           :student-id="studentInfo.id">
                        <template #default="{toggleVisible}">
                          <el-button class="is-last"
                                     size="mini"
                                     type="primary"
                                     @click="toggleVisible">学生成绩详情</el-button>
                        </template>
                      </StudentScorePopover>
                    </div>
                  </div>
                </div>
                <div class="apply-tip">
                  <el-alert type="warning"
                            :closable="false">
                    <template #title>
                      <ul>
                        <li>1、异动前，请先确认学生课程成绩是否录入提交并且认定，否则会出现成绩丢失的情况；</li>
                        <li>2、操作休学、转班、退学、休眠 时，该学生活动学期的选课若没有成绩，则会被删除；</li>
                      </ul>
                    </template>
                  </el-alert>
                </div>
              </div>
            </component>
          </div>
        </el-tab-pane>
      </MenuTabs>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>学生信息加载失败</div>
        <el-button type="text"
                   @click="loadStudentInfo">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import MenuTabs from '../../../../../../../widgets/custom/MenuTabs'
import StudentInfoPopover from '../../../../wrapper/popover/student/info'
import StudentScorePopover from '../../../../wrapper/popover/student/score'
import Hint from '../../../../../../../elements/Hint'
import StatusChangeProcedureApplySuspend from './suspend'
import StatusChangeProcedureApplyDropout from './dropout'
import StatusChangeProcedureApplyDormancy from './dormancy'
import StatusChangeProcedureApplyReenter from './reenter'
import StatusChangeProcedureApplyRollClass from './roll-class'
import StatusChangeProcedureApplyRollState from './roll-state'
import changeType from '../../../../../../../../constants/biz/status/changeType'
export default {
  name: 'StatusChangeProcedureApply',
  components: {
    MenuTabs,
    StudentInfoPopover,
    StudentScorePopover,
    Hint
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    extraParams: Object,
    visible: Boolean
  },
  data () {
    return {
      loading: false,
      studentInfo: null,
      changeTypes: [{
        ...changeType.SUSPEND,
        component: StatusChangeProcedureApplySuspend
      }, {
        ...changeType.DROPOUT,
        component: StatusChangeProcedureApplyDropout
      }, {
        ...changeType.DORMANCY,
        component: StatusChangeProcedureApplyDormancy
      }, {
        ...changeType.REENTER,
        component: StatusChangeProcedureApplyReenter
      }, {
        ...changeType.ROLL_CLASS,
        component: StatusChangeProcedureApplyRollClass
      }, {
        ...changeType.ROLL_STATE,
        component: StatusChangeProcedureApplyRollState
      }],
      current: ''
    }
  },
  filters: {
    status (val) {
      switch (val) {
        case '70':
          return 'is-primary'
        default:
          return 'is-warning'
      }
    },
    tuitionStatus (val) {
      switch (val) {
        case '1':
          return 'is-success'
        default:
          return 'is-danger'
      }
    }
  },
  methods: {
    loadStudentInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/status/change/procedure/studentInfo',
        method: 'post',
        data: this.$qs.stringify(this.$extend({
          postId: this.rowData.id
        }, this.extraParams))
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.studentInfo = response.data['studentInfo'] || {}
              break
            }
            default: {
              this.$message.error(response.data['message'])
              break
            }
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    onChangeSuccess () {
      this.$emit('hidePopoverAndRefresh')
    }
  },
  created () {
    this.current = this.changeTypes[0].code
  },
  mounted () {
    this.loadStudentInfo()
  },
  watch: {
    visible (val) {
      if (val) {
        this.loadStudentInfo()
      }
    }
  }
}
</script>

<style lang="scss">
  @import "../../../../../../../../styles/color";
  .status-change-procedure-apply {
    height: 100%;
    & > .menu-tabs {
      & > .el-tabs__header {
        margin-right: 0!important;
        border-right: 1px solid #ebeef5;
      }
      .apply-pane {
        height: 100%;
        .apply-student-info {
          & > .student-info {
            padding: 15px;
            background-color: #f6f6f6;
            border-radius: 4px;
            display: flex;
            align-items: center;
            & > .info-box {
              flex: auto;
              display: flex;
              align-items: center;
              flex-wrap: wrap;
              margin: -4px -15px;
              & > .info-item {
                padding: 4px 15px;
                & > .label {
                  color: #909399;
                  font-size: 12px;
                }
                & > .value {
                  color: #303133;
                  font-size: 12px;
                  &.bold {
                    font-weight: bold;
                  }
                  .is-primary {
                    color: $set-primary-color;
                  }
                  .is-warning {
                    color: $set-warning-color;
                  }
                  .is-success {
                    color: $set-success-color;
                  }
                  .is-danger {
                    color: $set-danger-color;
                  }
                }
              }
            }
            & > .append {
              margin-left: 15px;
              flex: none;
              & > .btn-group {
                display: flex;
                align-items: center;
                .el-button {
                  margin-left: 1px;
                  border-radius: 0;
                  padding: 6px 12px;
                  &.is-first {
                    border-top-left-radius: 20px;
                    border-bottom-left-radius: 20px;
                  }
                  &.is-last {
                    border-top-right-radius: 20px;
                    border-bottom-right-radius: 20px;
                  }
                }
              }
            }
          }
          & > .apply-tip {
            margin-top: 10px;
            .el-alert {
              & > .el-alert__content {
                padding: 2px 0;
                & > .el-alert__title {
                  font-size: 12px;
                  ul {
                    margin: unset;
                    padding: unset;
                    list-style: none;
                    & > li {
                      & + li {
                        margin-top: 1px;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>
